import React from 'react';
import styled from 'styled-components/macro';

export const CardRowLoading = () => {
  const cardWidths = [80, 90, 60, 70, 80, 60, 70, 80];
  return (
    <Loading>
      {cardWidths.map((cardWidth, i) => (
        <LoadingCard key={i}>
          <LoadingImage />
          <LoadingText width={cardWidth} />
        </LoadingCard>
      ))}
    </Loading>
  );
};

const Loading = styled.div`
  display: flex;
  flex-wrap: nowrap;
  margin-left: 15px;
  overflow: hidden;
  padding-top: 20px;
  width: calc(100% - 15px);
  @media screen and (min-width: 768px) {
    margin-left: 0;
    width: 100%;
  }
`;

const LoadingCard = styled.div`
  margin-right: 12px;
  max-width: 200px;
  min-width: calc(50% - 14px);
  flex-grow: 0;
  @media screen and (min-width: 476px) {
    min-width: calc(33% - 14px);
  }
  @media screen and (min-width: 717px) {
    min-width: calc(25% - 14px);
  }
  @media screen and (min-width: 1141px) {
    min-width: calc(20% - 14px);
  }
  @media screen and (min-width: 1528px) {
    min-width: 234px;
  }
`;

const LoadingImage = styled.div`
  ${(props) =>
    props.theme.name === 'light'
      ? `background: ${props.theme.color.black5}`
      : `background: ${props.theme.color.white5}`};
  border-radius: 8px;
  content: '';
  display: block;
  height: 0;
  padding-bottom: 56.25%;
  width: 100%;
`;

const LoadingText = styled.div`
  ${(props) =>
    props.theme.name === 'light'
      ? `background: ${props.theme.color.black5}`
      : `background: ${props.theme.color.white5}`};
  border-radius: 2px;
  content: '';
  display: block;
  height: 12px;
  margin-top: 12px;
  width: ${(props) => props.width}%;
`;
